module.exports = __webpack_public_path__ + "img/005.3e5f295c.jpg";